<template>
  <div v-if="!destroyed" class="notification">
    <div class="notification-content">
      <p class="notification-title">{{ notification.title }}</p>
      <p class="notification-desc">{{ notification.description }}</p>
    </div>
    <div class="notification-icon" @click="readNotification(notification)">
      <i class="fas fa-check-double m-0" title="Marcar como lido"></i>
    </div>
  </div>
</template>
<script>
export default {
  name: 'notification',
  data() {
    return {
      destroyed: false
    };
  },
  props: {
    notification: {
      type: Object,
      required: true
    }
  },
  methods: {
    readNotification(notification) {
      this.$store.dispatch('readNotification', notification.id);
    }
  }
};
</script>
<style lang="scss">
@import "src/assets/sass/now-ui-dashboard/variables.scss";

.navbar-nav-notifications {
  padding: 0;
  border-radius: 0.7em;

  .dropdown-menu {
    background-color: $black-bg-darker;
    color: $white-color;
    min-width: 35em;
    max-height: 35em;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    padding: 0;
    box-shadow: 2px 1px 10px 0px rgb(0, 0, 0);
    animation: translateY 0.2s ease-in-out;

    &.dropdown-menu-right {
      right: 1em !important;
    }
  }
}

.notification {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5em 1em;
  gap: 1em;

  &:hover {
    background-color: $black-bg;
  }

  i {
    color: $white-color;
    font-size: 1.2rem;
  }

  .notification-content {
    padding: 1em;
    display: flex;
    flex-direction: column;

    &:hover {
      background-color: $black-bg;
    }
  }

  .notification-icon {
    background-color: $secondary-color;
    border-radius: 50%;
    padding: 1em;
    cursor: pointer;

    &:hover {
      background-color: $primary-color-alert;
      animation: tilt-shaking 0.25s infinite;
    }
  }

  .notification-title {
    color: $secondary-color !important;
    font-weight: 900 !important;
    font-size: 1rem !important;
  }

  .notification-desc {
    color: $white-color !important;
    font-weight: 400 !important;
    font-size: 0.8rem !important;
  }
}

@keyframes tilt-shaking {
  0% { transform: rotate(0deg); }
  25% { transform: rotate(5deg); }
  50% { transform: rotate(0eg); }
  75% { transform: rotate(-5deg); }
  100% { transform: rotate(0deg); }
}

@keyframes translateY {
  0% {
    opacity: 0;
    transform: translateY(-60px);
  }

  80% {
    transform: translateY(5px);
  }

  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}

p.no-notifications {
  width: 100%;
  text-align: center;
  padding: 2em;
  font-size: 1 !important;
  font-weight: 900 !important;
  margin-left: 0 !important;
}
</style>
